import { HttpService } from '@/shared/services'
import License from '../models/License'
import List from '@/shared/dtos/List'
import GetDaysOutputDto from './interfaces/GetDaysOutputDto'
import GetDateEndOutputDto from './interfaces/GetDateEndOuputDto'
import CreateLicenseInputDto from './interfaces/CreateLicenseInputDto'
import GetLicenseTypeDto from './interfaces/GetLicenseTypeDto'
import GetLicenseDaysInputDto from './interfaces/GetLicenseDaysInputDto'
import GetLicenseDateEndInputDto from './interfaces/GetLicenseDateEndInputDto'

const http = new HttpService()

export const createLicenseRequest = async (
  licenseRequest: CreateLicenseInputDto
) => {
  const formData = new FormData()
  const { files, ...rest } = licenseRequest

  formData.append('license', JSON.stringify(rest))
  // Append each file individually
  if (files) {
    files.forEach((file: any, index: any) => {
      formData.append('files', file)
    })
  }

  const response = await http.post<any, string>('/licenses', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return response.data
}

export const getLicensesByEmployeeId = async (employeeId: string) => {
  const response = await http.get<List<License[]>>(`/licenses/${employeeId}`)
  return response.data
}

export const getLicenseTypes = async (employeeId: string) => {
  const response = await http.get<GetLicenseTypeDto>(
    '/licenses/types/' + employeeId
  )
  return response.data
}

export const getDaysByLicenseType = async (
  getLicenseDaysDto: GetLicenseDaysInputDto
) => {
  const response = await http.post<GetLicenseDaysInputDto, GetDaysOutputDto>(
    `/licenses/days`,
    getLicenseDaysDto
  )
  return response.data
}

export const getDateEnd = async (dto: GetLicenseDateEndInputDto) => {
  const response = await http.post<
    GetLicenseDateEndInputDto,
    GetDateEndOutputDto
  >(`/licenses/date-end`, dto)
  return response.data
}

export const deleteLicenseById = async (licenseId: string) => {
  const response = await http.delete<string>(`/licenses/${licenseId}`)
  return response.data
}
